
import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IDelteCard {
    cards: [];
    isHideTokenization: boolean;
    isReset: boolean;
}

export const initialValueDeleteCard: IDelteCard = {
    cards: [],
    isHideTokenization: false,
    isReset: false
}

const setDeleteParams = createSlice({
    name: 'SET_PARAMS_DELETE_CARD',
    initialState: initialValueDeleteCard,

    reducers: {
        setDeleteInfo: (state, {payload}) => (state = payload),
    }

})

export const {setDeleteInfo} = setDeleteParams.actions;

//EXPORT SELECTOR FOR CHILD
export const InfoDelete = (state: RootState) => state.setDeleteParams
export default setDeleteParams.reducer